import { RestaurantResponseType } from '../restaurant/restaurant.types';
import { ServiceChargeConfigurationType } from '../serviceCharge/serviceCharge.types';

export enum ServiceChargesType {
  Percent = 'percent',
  Fixed = 'fixed',
}

export interface createServiceChargeRequestType {
  name: string;
  amount: number;
  type: string;
  restaurantId: number;
}

export interface createServiceChargeResponseType {
  success: boolean;
  data: createServiceChargeResponse;
  message: string;
  error?: string | null;
}

export interface ServiceChargeResponseType {
  success: boolean;
  data: createServiceChargeResponse[];
  message: string;
  error?: string | null;
}

export interface createServiceChargeResponse {
  id: number;
  name: string;
  amount: number;
  type: string;
  restaurant: RestaurantResponseType;
  createdAt: Date;
  updatedAt: Date;
}
export interface IServiceChargeConfiguration {
  isChargeToOwner: boolean;
  isNonRevenue: boolean;
  isMinimumThresholdAmount: boolean;
  // isAutoApplyOnNonCreditCards: boolean;
  isAutoApply: boolean;
  isApplyOnDineIn: boolean;
  isApplyOnTakeAway: boolean;
  isApplicableOnDelivery: boolean;
  isApplyBeforeTax: boolean;
  isServiceChargeTaxed: boolean;
  minPartySize: number;
}

export interface IBaseServiceChargeRequest {
  name: string;
  type: ServiceChargeConfigurationType;
  minimumThresholdAmount: number | null;
  value: number | null;
  config?: IServiceChargeConfiguration; // Optional configuration
  restaurantId?: number;
  financialConfigurationId?: number;
  wavieFeeThreshold?: number | null;
  deliveryDistanceThreshold?: number | null;
  showOnKiosk?: boolean;
  showOnMpos?: boolean;
  showOnQR?: boolean;
  showOnline?: boolean;
  showOnPOS?: boolean;
  showOnThirdParty?: boolean;
}
export interface IServiceChargeRequest extends IBaseServiceChargeRequest {
  id?: number | null;
}

export interface IGetServiceChargeResponse {
  id: number;
  name: string;
  type: ServiceChargeConfigurationType;
  minimumThresholdAmount?: number | null;
  isMinimumThresholdAmount?: boolean;
  value: number;
  config: IServiceChargeConfiguration; // Optional configuration
  restaurantId?: number;
  financialConfigurationId: number;
  waiveFeeThreshold?: number;
  deliveryDistanceThreshold?: number;
  status: string;
  createdAt: string | Date | string;
  updatedAt: string | Date | string;
  deletedAt: null | Date | string;
  createdBy: null;
  updatedBy: null;
  deletedBy: null;
  showOnMpos?: boolean;
  showOnQR?: boolean;
  showOnline?: boolean;
  showOnPOS?: boolean;
  showOnNugget?: boolean;
  showOnThirdParty?: boolean;
  showOnKiosk?: boolean;
  financialConfiguration?: {
    id: number;
    configType: string;
    restaurantId: number;
    createdAt: string;
    updatedAt: string;
  };
}
export interface IServiceChargeRequestDto {
  data: IServiceChargeRequest;
  message: string;
  error?: string | null;
  success: boolean;
}

export interface IServiceChargeUpdateResponseDto {
  data: string;
  message: string;
  error?: string | null;
  success: boolean;
}

export interface IGetServiceChargeResponseDto {
  data: IServiceChargeList;
  message: string;
  error?: string | null;
  success: boolean;
}

export interface IGetByIdServiceChargeResponseDto {
  data: IGetServiceChargeResponse;
  message: string;
  error?: string | null;
  success: boolean;
}

export interface IServiceChargeList {
  serviceChargeList: IGetServiceChargeResponse[];
  totalCount: number;
}

export interface IServiceChargeData {
  serviceChargeData: IGetServiceChargeResponse;
  restaurantId: number;
}
export interface IServiceChargeRequestData {
  serviceCharge: IServiceChargeRequest;
  restaurantId?: number;
}
export type ServiceChargeFilter = Partial<IGetServiceChargeResponse>;
export interface IServiceChargeListItem {
  id: number;
  name: string;
  type: string;
  value: number;
  isApplicableOnDelivery?: boolean;
  isApplyOnTakeAway?: boolean;
  isApplyOnDineIn?: boolean;
}

export interface ServiceChargesVisibilityValues {
  showOnPOS: boolean;
  showOnQR: boolean;
  showOnline: boolean;
  showOnThirdParty: boolean;
  showOnMpos: boolean;
  showOnKiosk: boolean;
  showOnNugget: boolean;
}
